<template>
  <div class="edit-btn" :class="editImg ? 'custom-edit-btn' : 'common-edit-btn'"  :style="editStyle" @click.prevent="goRoute">
    <i v-if="!editImg" class="iconfont icon-xie"></i>
    <span v-if="!editImg">{{editText}}</span>
  </div>
  <!-- <router-link :to="'/publish/'+ id" class="edit-btn" :style="editStyle">
    <i class="iconfont icon-xie"></i>
    <span>{{editText}}</span>
  </router-link> -->
</template>
<script>
  import {isAppOrWeixin} from 'assets/js/community.js';
  export default {
    name: 'editButton',
    props:{
      id:{
        type: Number,
        default: 2
      },
      config: {
        type: Object
      },
      // editText:{
      //   type: String,
      //   default: '发布'
      // }
    },
    created(){
      console.log('config:', this.config);
    },
    computed:{
      tokens(){
        return this.$store.state.tokens;
      },
      editImg(){
        return this.config ? this.config.editImg : '';
      },
      editText(){
        return this.config ? this.config.editText : '发布';
      },
      editStyle(){
        return this.config ? (
          this.config.editImg ? 
          `background: url(${this.config.editImg}) center center no-repeat;background-size:5em auto` : 
          (this.config.edit_btn1 ? 
          `background-image: -webkit-linear-gradient( -46deg, ${this.config.edit_btn0} 0%, ${this.config.edit_btn1} 100%);`
          : `background: ${this.config.edit_btn0};`)
        ) : '';
      }
    },
    methods: {
      async goRoute(){
        let t = await isAppOrWeixin();
        if(t){
          let tokens = this.tokens || await this.$store.dispatch('cbgcAuth');
          if(tokens.status){
            this.$emit('showTip', tokens.message);
            return;
          }
          tokens = typeof tokens == 'string' ? tokens : tokens.access_token;
          // tokens = tokens.access_token ? tokens : tokens.meta.custom;
          this.$router.push({
            name: this.config.editLink || 'Publish',
            params: {
              id: this.id
            }
          });
        }else{
          this.$emit('showTip', '请在川观新闻客户端或者微信参与互动');
        }
        
      }
    }
  }
</script>
<style lang="scss">
  .edit-btn{
    display: block;
    position: fixed;
    right: .5em;
    bottom: 5em;
    z-index: 101;
    width: 5em;
    height: 4.2em;
    padding: .4em 0;
    border-radius: 100%;
    ;
    transform: scale(.8);
    span{
      font-size: 1.2em;
      display: block;
      padding-bottom: .2em;
    }
    .iconfont{
      font-size: 2em;
      margin-right: 0;
    }
  }
  .common-edit-btn{
    background-color: #da251d;
    border:1px solid #fff;
    box-shadow: 0 0 2px rgba(0,0,0,.5);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    color: #fff
  }
  .custom-edit-btn{
    box-shadow: 0 4px 20px rgba(163,13,13,.54);
  }
</style>
